import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponent } from '@core/header/header.component';
import { SidenavComponent } from '@core/sidenav/sidenav.component';

@Component({
  selector: 'app-root',
  imports: [HeaderComponent, SidenavComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
